<template>
  <div>
    <b-modal :active.sync="displayISO3166" has-modal-card :width="800">
      <div class="modal-card" style="width: 800px">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t('compCarbonFormsTravelsHelpFileFormat.title-iso') }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-table :data="ISO3166" :columns="ISOColumns"></b-table>
        </section>
      </div>
    </b-modal>

    <b-modal
      :active.sync="displayMapping"
      has-modal-card
      :width="800"
      @close="displayMapping = false"
    >
      <div class="modal-card" style="width: 800px">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{
              $t('compCarbonFormsTravelsHelpFileFormat.title-possible-values')
            }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-table :data="mapping">
            <b-table-column
              field="key"
              :label="$t('compCarbonFormsTravelsHelpFileFormat.header-key')"
              v-slot="props"
            >
              {{ $t(props.row.key) }}
            </b-table-column>

            <b-table-column
              field="value"
              :label="$t('compCarbonFormsTravelsHelpFileFormat.header-values')"
              v-slot="props"
            >
              {{ props.row.values }}
            </b-table-column>
          </b-table>
        </section>
      </div>
    </b-modal>

    <template v-if="formats.length === 1">
      <b-notification :has-icon="true" icon="file" :closable="false">
        <component
          :is="importName(formats[0])"
          @displayISO="displayISO3166 = true"
          @displayPositionMapping="displayPositionMapping"
          @displayPurposeMapping="displayPurposeMapping"
        />
      </b-notification>
    </template>
    <template v-else>
      <b-notification :has-icon="true" icon="file" :closable="false">
        {{ $t('compCarbonFormsTravelsHelpFileFormat.text') }}
        <br /><br />
      </b-notification>
      <b-tabs class="block">
        <b-tab-item
          v-for="(format, index) in formats"
          :key="index"
          :label="format"
        >
          <component
            :is="importName(format)"
            @displayISO="displayISO3166 = true"
            @displayPositionMapping="displayPositionMapping"
            @displayPurposeMapping="displayPurposeMapping"
          />
        </b-tab-item>
      </b-tabs>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import ISO3166 from '@/../data/utils/ISO3166.json'
import { useCoreStore } from '@/stores/core.js'

import { inverseMapping } from '@/utils/utils'

export default {
  name: 'HelpFileFormat',
  data () {
    return {
      displayISO3166: false,
      ISO3166: ISO3166,
      ISOColumns: [
        {
          field: 'names',
          label: this.$t('compCarbonFormsTravelsHelpFileFormat.header-iso-1'),
          centered: true
        },
        {
          field: 'iso',
          label: this.$t('compCarbonFormsTravelsHelpFileFormat.header-iso-2'),
          centered: true
        }
      ],
      displayMapping: false,
      mapping: [],
      mappingColumns: [
        {
          field: 'key',
          label: this.$t('compCarbonFormsTravelsHelpFileFormat.header-key'),
          centered: true
        },
        {
          field: 'values',
          label: this.$t('compCarbonFormsTravelsHelpFileFormat.header-values'),
          centered: true
        }
      ]
    }
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    formats: function () {
      return this.coreStore.setting('travels', 'FILE_FORMATS').value
    },
    positions: function () {
      let m = inverseMapping(
        this.coreStore.conf.TRAVEL_POSITION_DICTIONARY.value
      )
      return Object.entries(m).map(([k, v]) => {
        return { key: k, values: v }
      })
    },
    purposes: function () {
      let m = inverseMapping(
        this.coreStore.conf.TRAVEL_PURPOSE_DICTIONARY.value
      )
      return Object.entries(m).map(([k, v]) => {
        return { key: k, values: v }
      })
    }
  },
  methods: {
    displayPositionMapping () {
      this.displayMapping = true
      this.mapping = this.positions
    },
    displayPurposeMapping () {
      this.displayMapping = true
      this.mapping = this.purposes
    },
    importName: function (format) {
      return format + 'Help'
    }
  },
  beforeMount () {
    for (let format of this.formats) {
      Vue.component(
        this.importName(format),
        // A dynamic import returns a Promise.
        () =>
          import(
            '@/components/carbon/forms/travels/formats/' + format + '/Help.vue'
          )
      )
    }
  }
}
</script>

<style>
.notification a:not(.button):not(.dropdown-item) {
  text-decoration: none;
}
</style>
